export default __webpack_public_path__ + "static/media/remove@3x.4b27134a.png";